import { useNavigate } from 'react-router-dom';
import React from 'react';
import { useFormContext } from 'framework/form';
import { FormFieldsData } from 'validation-schema-library/build/validation/types';
import { Stack } from '@mui/material';
import { Button } from 'framework/ui/mui-builder';

interface FormSubmitButtonsProps {
  additionalOnSubmitAction?: () => void;
  onCancelAction?: Nullable<() => void>;
  isVisible?: ((data: FormFieldsData) => boolean) | boolean;
  isCancelButtonVisible?: boolean;
  submitButtonText?: ((data: FormFieldsData) => string) | string;
  cancelButtonText?: ((data: FormFieldsData) => string) | string;
}

const FormSubmitButtons = ({
  onCancelAction,
  additionalOnSubmitAction,
  isVisible = true,
  isCancelButtonVisible = true,
  submitButtonText = 'Submit',
  cancelButtonText = 'Cancel',
}: FormSubmitButtonsProps) => {
  const navigate = useNavigate();
  const { data = {}, submitForm, isSubmitEnabled, isLoadingArtifact } = useFormContext();

  const onCancel = onCancelAction || (() => navigate(-1));
  const action = () => {
    if (submitForm) {
      submitForm();
    }

    if (additionalOnSubmitAction) {
      additionalOnSubmitAction();
    }
  };

  if (isVisible instanceof Function ? !isVisible(data) : !isVisible) {
    return null;
  }

  return (
    <Stack spacing={1} direction="row" justifyContent="flex-end" alignItems="center">
      {isCancelButtonVisible && (
        <Button data-testid="cancel-btn" variant="outlined" type="button" onClick={onCancel}>
          {cancelButtonText instanceof Function ? cancelButtonText(data) : cancelButtonText}
        </Button>
      )}
      <Button
        data-testid="submit-button"
        type="submit"
        onClick={action}
        disabled={!isSubmitEnabled || isLoadingArtifact}
      >
        {submitButtonText instanceof Function ? submitButtonText(data) : submitButtonText}
      </Button>
    </Stack>
  );
};

export default FormSubmitButtons;
